interface Response {
  scrollToTop: () => void
}

export const useScrollToTop = (): Response => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

  return { scrollToTop }
}
